"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var translations_1 = require("@shared/constants/translations");
var context_meta_1 = require("@shared/types/context-meta");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var common_1 = require("./common");
var SUPPORTED_FILE_FORMATS = ['csv', 'tsv'];
var DynamicTranslationUtil = /** @class */ (function () {
    function DynamicTranslationUtil(
    // @ts-ignore
    $http, 
    // @ts-ignore
    $routeParams, 
    // @ts-ignore
    $sanitize, 
    // @ts-ignore
    $q, 
    // @ts-ignore
    $translate, 
    // @ts-ignore
    tmhDynamicLocale, 
    // @ts-ignore
    dynamicTranslationHelperUtils, activeReport, 
    // @ts-ignore
    containers, 
    // @ts-ignore
    env, 
    // @ts-ignore
    rsState, 
    // @ts-ignore
    navigationService, 
    // @ts-ignore
    widgetManager, 
    // @ts-ignore
    sourceManagement, 
    // @ts-ignore
    API_ROUTES, triggerOverrides, 
    // @ts-ignore
    OVERRIDE_EVENTS, 
    // @ts-ignore
    eventService, 
    // @ts-ignore
    EVENTS) {
        var _this = this;
        this.$http = $http;
        this.$routeParams = $routeParams;
        this.$sanitize = $sanitize;
        this.$q = $q;
        this.$translate = $translate;
        this.tmhDynamicLocale = tmhDynamicLocale;
        this.dynamicTranslationHelperUtils = dynamicTranslationHelperUtils;
        this.activeReport = activeReport;
        this.containers = containers;
        this.env = env;
        this.rsState = rsState;
        this.navigationService = navigationService;
        this.widgetManager = widgetManager;
        this.sourceManagement = sourceManagement;
        this.API_ROUTES = API_ROUTES;
        this.triggerOverrides = triggerOverrides;
        this.OVERRIDE_EVENTS = OVERRIDE_EVENTS;
        this.eventService = eventService;
        this.EVENTS = EVENTS;
        this.availableLanguageCodesCache = [];
        this.initializeReportLanguage = function () {
            return _this.getDefaultLanguageCode().then(function (languageCode) {
                languageCode = _this.$sanitize(languageCode);
                return _this.updateLanguageCode(languageCode);
            });
        };
        this.getFormats = function () {
            return SUPPORTED_FILE_FORMATS;
        };
        // Exports a valid csv/tsv file from the translation-service
        this.export = function (format) {
            var containerId = _this.env.get('containerId');
            var baseUrl = _this.dynamicTranslationHelperUtils.getBaseUrl();
            var surveyId = _this.$routeParams.surveyId;
            var url = baseUrl + "/export?format=" + format + "&surveyId=" + surveyId + "&containerId=" + containerId + "&isFile=true";
            if (_this.$routeParams.dashboardId) {
                url += '&dashboardId=' + _this.$routeParams.dashboardId;
            }
            if (_this.$routeParams.projectId) {
                url += '&projectId=' + _this.$routeParams.projectId;
            }
            $('<iframe class="download-iframe"></iframe>')
                .attr({
                src: url,
                style: 'visibility:hidden; display: none;'
            })
                .appendTo('body');
        };
        // Imports a valid csv/tsv file to the translation-service
        // @ts-ignore
        this.import = function (file) {
            var path = _this.dynamicTranslationHelperUtils.getBaseUrl() + "/import";
            var formData = new FormData();
            formData.set('File', file);
            return _this.$http({
                url: path,
                data: formData,
                method: 'POST',
                headers: {
                    'Content-Type': undefined
                },
                transformRequest: angular_1.identity
            });
        };
        /**
         * Used by bar and line widgets to migrate translated keys to a static key
         * For example, if the user had previously translated the metric 'Count' in French,
         * it would be keyed by 'Compte' (the French translation for Count).
         */
        this.migrateLabelOverrides = function (state, widget) {
            if (lodash_1.default.get(widget, 'status.status') === 'DATA_LOADED') {
                // Need to make sure the data is loaded so we can check the dimensionality
                var numDimensions = lodash_1.default.get(state, 'data.dimensions.length');
                if (numDimensions <= 1) {
                    var metric = state.data.metrics[0];
                    var labelOverrides = lodash_1.default.get(state, 'viewConfig.labelOverrides');
                    _this.dynamicTranslationHelperUtils.migrateSingleMetricLabelOverrides(metric, labelOverrides);
                }
                _this.addTranslationsToExistingOverrides(state, widget);
            }
        };
        /**
         * Used by all (eng) widgets to save existing label overrides automatically to
         * the translation service and have them pull through in the spreadsheet
         */
        this.addTranslationsToExistingOverrides = function (state, widget) {
            var isEnabled = _this.dynamicTranslationHelperUtils.isDynamicTranslationsSupported();
            if (isEnabled && lodash_1.default.get(widget, 'status.status') === 'DATA_LOADED') {
                var viewConfig = lodash_1.default.get(state, 'viewConfig') || {};
                var orderedMetrics = lodash_1.default.get(state, 'dataConfig.orderedMetrics', []);
                if (lodash_1.default.get(widget, 'lifecycle')) {
                    if (!_this.dynamicTranslationHelperUtils.hasTranslationAttributes(viewConfig, orderedMetrics)) {
                        // This should only run once for reports that have widgets that were added
                        // prior to dynamic translations and will attach translationId and translatableAttribute fields
                        _this.dynamicTranslationHelperUtils
                            .addDynamicTranslationsWidgetAttributes(viewConfig, orderedMetrics);
                        widget.lifecycle.onViewConfigUpdated();
                    }
                }
            }
        };
        /**
         * Updates the report language, causing widgets to rerender
         */
        this.updateLanguageCode = function (languageCode) {
            languageCode = languageCode || _this.$sanitize(_this.activeReport.getLanguageCode()) || translations_1.DEFAULT_LANGUAGE_CODE;
            _this.setUserLanguage(languageCode);
            return _this.activeReport.updateLanguageCode(languageCode, _this.shouldSaveLanguageToContainer()).catch(function (error) {
                console.error('Error updating language code', error);
            }).then(function () {
                _this.rsState.clearCache();
                // Fetch translated metadata
                var isEnabled = _this.dynamicTranslationHelperUtils.isDynamicTranslationsSupported();
                var getAndUpdateContainerMetaPromise = isEnabled ? _this.getAndUpdateContainerMeta() : _this.$q.when();
                getAndUpdateContainerMetaPromise.finally(function () {
                    _this.widgetManager.notifyAllWidgets('widgetSectionUpdated');
                    /**
                     * Trigger a report language change event when the context meta is updated
                     * Triggering it before the update finishes causes issues for the header/footer pulling
                     * in stale traslations.
                     */
                    _this.eventService.trigger(_this.EVENTS.REPORT_LANGUAGE_CHANGED);
                });
                if (isEnabled && _this.$translate.use() !== languageCode) {
                    // Update static translations
                    _this.$translate.refresh(languageCode).finally(function () {
                        _this.$translate.use(languageCode);
                    });
                    _this.tmhDynamicLocale.set(common_1.getAngularLocale(languageCode));
                    moment.locale(common_1.getMomentLocale(languageCode));
                }
                return getAndUpdateContainerMetaPromise;
            });
        };
        /**
         * A cache for the available language codes
         */
        this.getAvailableLanguageCodes = function () {
            var promises = [];
            var configFlags = _this.triggerOverrides({
                event: _this.OVERRIDE_EVENTS.CONFIG_FLAGS,
                sync: true
            });
            var isEnabled = _this.dynamicTranslationHelperUtils.isDynamicTranslationsSupported();
            if (configFlags && configFlags.useEIWidgetServiceLanguages && isEnabled) {
                // for EE-flavor reports, we don't use survey translations
                promises.push(_this.getEIWidgetServiceLanguages());
            }
            else {
                var sourceIds = lodash_1.default.filter(_this.sourceManagement.getSources());
                promises = lodash_1.default.map(sourceIds, _this.getAvailableLanguageCodesForSourceId);
            }
            if (isEnabled) {
                var containerLanguages = _this.getAvailableLanguageCodesForContainer();
                // @ts-ignore
                promises.push(containerLanguages);
            }
            // @ts-ignore
            return _this.$q.all(promises).then(function (res) {
                return lodash_1.default.chain(res).flatten().filter().union().value();
                // @ts-ignore
            }).then(function (languageCodes) {
                return _this.triggerOverrides({
                    event: _this.OVERRIDE_EVENTS.LANGUAGE_CODES,
                    data: languageCodes
                });
            });
        };
        /**
         * GET request that proxies to surveyAPI to get the list of available languages for a source
         */
        this.getAvailableLanguageCodesForSourceId = function (sourceId) {
            var path = "" + _this.API_ROUTES.SURVEYS + sourceId + "/languages";
            return _this.$http({
                url: path,
                method: 'GET',
                params: {
                    hash: _this.$routeParams.publicHash
                }
                // @ts-ignore
            }).then(function (res) {
                return res.data;
                // @ts-ignore
            }).catch(function (error) {
                console.error('Error getting survey language', error);
            });
        };
        this.getEIWidgetServiceLanguages = function () {
            var path = _this.API_ROUTES.DYNAMIC_TRANSLATIONS + "/EIWidgetServiceLanguages";
            return _this.$http({
                url: path,
                method: 'GET',
                params: {
                    dashboardId: _this.$routeParams.dashboardId
                }
                // @ts-ignore
            }).then(function (res) {
                return res.data;
                // @ts-ignore
            }).catch(function (error) {
                console.error('Error getting EIWidgetService dashboard languages', error);
                return [];
            });
        };
        /**
         * GET request that proxies to containersAPI to get the list of availableLanguaages for the containerId
         * @return {Promise<Array<String>>} - list of dynamically translated languages for the container
         */
        this.getAvailableLanguageCodesForContainer = function () {
            var path = _this.API_ROUTES.DYNAMIC_TRANSLATIONS + "/containerLanguages";
            return _this.$http({
                url: path,
                method: 'GET',
                params: {
                    hash: _this.$routeParams.publicHash,
                    containerId: _this.$routeParams.containerId
                }
                // @ts-ignore
            }).then(function (res) {
                if (res && lodash_1.default.isArray(res.data)) {
                    // @ts-ignore
                    // @ts-ignore
                    return res.data.map(function (code) { return translations_1.MONOLITH_LANGUAGE_MAPPINGS[code] || code; });
                }
                return [];
                // @ts-ignore
            }).catch(function (error) {
                console.error('Error getting container languages', error);
            });
        };
        /**
         * GET request that proxies to surveyAPI to get the default survey language
         * @returns {String} languageCode
         */
        this.getDefaultSurveyLanguageCode = function () {
            var surveyId = _this.$sanitize(_this.$routeParams.surveyId);
            var path = _this.API_ROUTES.SURVEYS + surveyId + "/defaultSurveyLanguage";
            // @ts-ignore
            return _this.$http.get(path).then(function (res) {
                return res.data;
                // @ts-ignore
            }).catch(function (error) {
                console.error('Error getting default survey language code', error);
                throw error;
            });
        };
        this.getLanguageHeaders = function () {
            var user = _this.env.get('user') || {};
            var language = common_1.getUserLanguage(user);
            return common_1.getLanguageHeaders(language);
        };
        this.setCachedAvailableLanguageCodes = function (availableLanguageCodes) {
            // @ts-ignore
            _this.availableLanguageCodesCache = availableLanguageCodes;
        };
        this.getCachedAvailableLanguageCodes = function () {
            return lodash_1.default.cloneDeep(_this.availableLanguageCodesCache);
        };
        /**
         * GET request that fetches translated container metadata based on current report language
         * and set it to active report.
         */
        this.getAndUpdateContainerMeta = function () {
            // @ts-ignore
            return _this.containers.getContainer(_this.activeReport.getReportId(), null, false).then(function (container) {
                _this.activeReport.updateDescription(lodash_1.default.get(container, 'definition.description'));
                return _this.activeReport.updateMetadata(lodash_1.default.get(container, 'definition.contextMeta'));
                // @ts-ignore
            }).catch(function (error) {
                console.error('Error getting container metadata', error);
            });
        };
        /**
         * Containers may not initially have the required translation attributes
         * This function makes sure that the attributes are present.
         */
        this.setMissingTranslationAttributes = function () {
            _this.setMissingTranslationAttributesForCustomFilters();
        };
        /**
         * Tries to get the language code from:
         * 		0. languageCode passed in
         * 		1: the url
         * 		2: the container
         * 		3: the survey definition
         * @return {Promise<string>} languageCode
         */
        this.getDefaultLanguageCode = function (languageCode) {
            if (_this.$routeParams.lang) {
                return _this.$q.when(_this.getLanguageCodeFromURL());
            }
            var configFlags = _this.triggerOverrides({
                event: _this.OVERRIDE_EVENTS.CONFIG_FLAGS,
                sync: true
            });
            var isEnabled = _this.dynamicTranslationHelperUtils.isDynamicTranslationsSupported();
            if ((configFlags === null || configFlags === void 0 ? void 0 : configFlags.shouldUseUserLanguage) &&
                isEnabled && !languageCode) {
                // This is for eiws and 360 reports, where public reports
                // are not enabled and we always have a concept of a user.
                var user = _this.env.get('user');
                languageCode = user.language;
            }
            if (languageCode) {
                return _this.$q.when(languageCode);
            }
            if (!_this.navigationService.isEditor) {
                // Public report does not have a `lang` query param in the url
                return _this.$q.when(_this.getDefaultContainerLanguageCode());
            }
            return _this.getDefaultSurveyLanguageCodeWithFallback();
        };
        this.getDefaultContainerLanguageCode = function () {
            return _this.$sanitize(_this.activeReport.getLanguageCode());
        };
    }
    DynamicTranslationUtil.prototype.setMissingTranslationAttributesForCustomFilters = function () {
        var customFiltersMap = this.activeReport.getMetadata(context_meta_1.CONTEXT_META_VARS.CUSTOM_FILTERS);
        var newCustomFiltersMap = this.dynamicTranslationHelperUtils
            .addDynamicTranslationsAttributesForCustomFilters(customFiltersMap);
        if (!lodash_1.default.isEqual(customFiltersMap, newCustomFiltersMap)) {
            this.activeReport.setMetadata(context_meta_1.CONTEXT_META_VARS.CUSTOM_FILTERS, newCustomFiltersMap);
        }
    };
    DynamicTranslationUtil.prototype.getLanguageCodeFromURL = function () {
        return lodash_1.default.toUpper(this.$routeParams.lang);
    };
    /**
     * Get the default survey language code
     * @returns {Promise<String>} languageCode
     */
    DynamicTranslationUtil.prototype.getDefaultSurveyLanguageCodeWithFallback = function () {
        var _this = this;
        return this.getDefaultSurveyLanguageCode().catch(function () {
            return _this.$q.when(_this.getDefaultContainerLanguageCode());
        });
    };
    /**
     * Sets the ripsaw env user language to be used
     * by ripsaw-client when setting the content-language header
     */
    // @ts-ignore
    DynamicTranslationUtil.prototype.setUserLanguage = function (languageCode) {
        var user = this.env.get('user') || {};
        user.language = languageCode;
        this.env.set('user', user);
    };
    DynamicTranslationUtil.prototype.shouldSaveLanguageToContainer = function () {
        return this.navigationService.isEditor && !this.navigationService.isExport;
    };
    DynamicTranslationUtil.$inject = [
        '$http',
        '$routeParams',
        '$sanitize',
        '$q',
        '$translate',
        'tmhDynamicLocale',
        'prDynamicTranslationsHelperUtils',
        'prActiveReport',
        'rsContainers',
        'rsEnvironment',
        'rsState',
        'pr.navigationService',
        'pr.widgetManager',
        'pr.sourceManagement',
        'pr.API_ROUTES',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS',
        'prEventService',
        'pr.EVENTS'
    ];
    return DynamicTranslationUtil;
}());
(function (angularModule) {
    angularModule.service('prDynamicTranslationsUtil', DynamicTranslationUtil);
})(angular_1.module('qualtrics.pr'));
